var _clipPath, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIbmLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-1v83h55.9v236H1.5v82h195v-82h-55.9V82H195V-1zm554 1v82h55.9v236h-54.4v82h139V172l82.7 228 1.68.04 81.2-228v228h140v-82h-55.9v-236h54.4v-82h-156l-64.7 183-65.5-183z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M222 0v82h55.9v130h215v-24.9s18-14 23.8-27.4l11.5-25.9s5.35-14.5 5.35-27.4l-2.3-25.9s-3.62-21.1-9.92-27.3l-22.3-25.9S470.73-.1 433.13-.1zm140 82h82v76h-82z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "matrix(1 0 0 -1 0 400)",
    xlinkHref: "#B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.7h1030v53.2H0m0 53.2h975v53.2H0v53.2h975v53.2H0m0 53.2h1030v53.2H0",
    clipPath: "url(#A)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 27.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmLogo);
export default __webpack_public_path__ + "static/media/ibm_logo.00cabc7626b3d6490ae1119af9d16945.svg";
export { ForwardRef as ReactComponent };